import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Venta, Mercaderia, DetalleVenta } from 'src/app/model/index.model';
import { ActivatedRoute, Router } from '@angular/router';
import { VentaService, DetalleVentaService, WorkshoppingService, ApiService } from 'src/app/service/index.service';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-frm-venta',
  templateUrl: './frm-venta.component.html',
  styleUrls: ['./frm-venta.component.scss'],
  providers: [WorkshoppingService, ApiService]
})
export class FrmVentaComponent implements OnInit {
  /*
   * Varaiables de control para comportamientos del componente
  */


  mercaderia: Mercaderia;
  detalle: DetalleVenta[];

  cargainicial: DetalleVenta[];
  clientes

  @Output()
  finalizado: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  @Output()
  cancelado: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  /*
   * control de operaciones a realizar
   */
  proccess: Boolean = false;

  public entity = 'ventas';
  public item: Venta;
  private id: number;
  total: number = 0

  url: string = environment.configUrl;;
  cotizacion: number = 1
  conf: any


  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private wsdl: VentaService,
    private wswork: WorkshoppingService,
    private wsdlApi: ApiService,
    private wsdldp: DetalleVentaService) {
    this.item = new Venta();
    // this.detalle = UturuncoUtils.getSession("detalle") ? JSON.parse(UturuncoUtils.getSession("detalle")) : [];
    this.cargainicial = [];
    this.calcularT();
  }

  async getCotizacion() {
    try {
      this.proccess = true;
      let data = await this.wsdlApi.getUsd().then();
      const result = JSON.parse(JSON.stringify(data));
      this.cotizacion = result.venta;
    } catch (error) {
      this.proccess = false;
    } finally {
      this.proccess = false;
    }
  }
  async ngOnInit() {
    this.id = this.route.snapshot.params.id;
    await this.http.get(this.url).subscribe(res => {
      this.conf = res;
      if (this.conf.dolar) {
        this.getCotizacion();
      } else {
        this.cotizacion = 1
      }
    });
    this.findID();
    this.listCliente();

  }

  async findID() {
    try {
      if (this.id > 0) {
        const data = await this.wsdl.doFind(this.id);
        const res = JSON.parse(JSON.stringify(data));
        if (res.code == 200) {
          this.item = res.data;

          // Obtener los detalles existentes de la venta
          const detda = await this.wsdldp.getCriteria(this.id, 1, 1000);
          const detres = JSON.parse(JSON.stringify(detda));
          this.detalle = detres.code == 200 ? detres.data.docs : [];

          // Inicializar WorkshoppingService con los detalles cargados
          this.wswork.detalle = [...this.detalle];

          this.cargainicial = this.detalle;
          this.calcularT();
        }
      }
    } catch (error) {
      UturuncoUtils.showToas("Error inesperado", "error");
    }
  }

  async listCliente() {
    try {
      this.proccess = true;
      const data = await this.wsdldp.getCliente();
      const result = JSON.parse(JSON.stringify(data));

      if (result.code == 200) {
        this.clientes = result.data;

        // Seleccionar cliente por defecto
        if (this.clientes.length > 0) {
          this.item.cliente = this.clientes[0].cliente;
        } else {
          this.item.cliente = 'CONSUMIDOR FINAL';
        }
      } else if (result.code === 401) {
        // logout app o refresh token
      } else {
        this.clientes = [];
        UturuncoUtils.showToas(result.msg, "error");
        this.item.cliente = "CONSUMIDOR FINAL";
      }

    } catch (error) {
      this.item.cliente = 'CONSUMIDOR FINAL';
    } finally {
      this.proccess = false;
    }
  }


  doAction(f: NgForm) {
    if (this.detalle.length == 0) {
      UturuncoUtils.showToas("Debe ingresar algun Producto para cerrar la venta", 'warning')
      return
    }
    /* validar */
    this.item.usuario = JSON.parse(UturuncoUtils.getSession("user"));


    if (f.valid) {
      if (this.id > 0) {
        //editar
        this.doEdit();
      } else {
        this.doCreate();
      }
    } else {
      alert('Validar');
    }
  }

  async doEdit() {
    try {
      this.detalle = [...this.wswork.detalle];
      this.calcularT();
      this.proccess = true;
      let arra = this.detalle.map(e => "[" + e.cantidad + "] " + e.mercaderia.nombre)
      this.item.descripcion = arra.toString();
      this.item.estado = "editada"
      this.item.total = this.total
      const res = await this.wsdl.doUpdate(this.item, this.item.id).then();
      const result = JSON.parse(JSON.stringify(res));
      if (result.code == 200) {
        for (let index = 0; index < this.detalle.length; index++) {
          const det = this.detalle[index];
          det.venta = this.item;
          if (det.id == undefined) {
            try {
              let rr = await this.wsdldp.doInsert(det);
              console.log("agregado insert edit vente", rr)
            } catch (error) {
              console.log("error detalle", error)
            }
          } else {
            let rr = await this.wsdldp.doUpdate(det, det.id);
            console.log("detalle no agregado ", det)
          }
        }

        UturuncoUtils.showToas("Se actualizado correctemte", "success");
        this.cargainicial = [];
        this.item = new Venta();
        this.item.cliente = this.clientes[0].cliente
        this.wswork.limpiarCarrito();
        this.detalle = [];
        this.calcularT();

        this.finalizado.emit(true);
        // this.back()
      } else if (result.code == 666) {
        // logout app o refresh token
        this.back();

      } else {
        UturuncoUtils.showToas(result.msg, "error");
        this.back();

      }
    } catch (error) {
      UturuncoUtils.showToas("Excepción: " + error.message, "error");
      this.back();
    } finally {
      this.proccess = false;

    }
  }

  async doCreate() {
    try {
      this.detalle = [...this.wswork.detalle];
      this.calcularT();
      this.proccess = true;
      let arra = this.detalle.map(e => "[" + e.cantidad + "] " + e.mercaderia.nombre)
      this.item.descripcion = arra.toString();
      this.item.estado = 'pedida'
      const res = await this.wsdlApi.doVentaGenerate(this.item, this.detalle, this.cotizacion).then()
      const response = JSON.parse(JSON.stringify(res))
      if (response.code == 200) {

        UturuncoUtils.showToas("Se creo correctemte", "success");
        this.cargainicial = [];
        this.item = new Venta();
        this.wswork.limpiarCarrito();
        this.detalle = [];
        this.calcularT();
        this.item.cliente = this.clientes[0].cliente

        this.finalizado.emit(true);
        this.back()
      } else if (response.code == 666) {
        // logout app o refresh token
        this.back();

      } else {
        UturuncoUtils.showToas(response.msg, "error");
        this.back();
      }
    } catch (error) {
      UturuncoUtils.showToas("Excepción: " + error.message, "error");
      this.back();
    } finally {
      this.proccess = false;
    }
  }

  back() {
    this.router.navigateByUrl("admin/" + this.entity.toLowerCase() + "/lst");
  }

  cond(event: 'contado' | 'mayorista' | 'tarjeta') {
    if (this.item.condicion !== event) {
      this.item.condicion = event;
      this.wswork.actualizarCarritoPorCondicion(event);
      this.detalle = this.wswork.detalle;
      this.calcularT();
    }
  }

  venta(event) {
    //this.wswork.detalle = event;
    this.detalle = event;
    this.calcularT();
  }

  async calcularT() {
    this.total = await this.wswork.calculateTotal();
  }


  getRR() {
    return this.proccess;
  }

}
